import "./OurServices.module.css";
import Header from "@/reusable_sections/Header";
import FacilitySolutionsSuite from "./sections/FacilitySolutionsSuite";
import MaintenanceFaq from "./sections/MaintenanceFaq";
import Footer from "@/reusable_sections/Footer";
export default function OurServicesPage() {
  return <div>
      <Header />
      <FacilitySolutionsSuite />
      <MaintenanceFaq />
      <Footer />
    </div>;
}